import { pollRequest } from "../functions/util"

export default (dis, store, client) => {
  const update = (payload) => {
    dis({ type: 'analytics/upsert', payload })
  }

  function setDefaultRules() {
    const rules = [{ 'id': 'root', 'type': 'group', 'operator': 'AND', 'ruleIds': [] }]
    dis({ type: 'rules/setAll', payload: rules })
  }

  return { update, setDefaultRules }
}
